import { ModalProps } from './modal';

export const baseModalProps: () => ModalProps = () => ({
  heading: 'A modal with cancel and continue buttons',
  subHeading: 'And a cute, little sub header',
  actionButtonText: 'Continue',
  cancelButtonText: 'Cancel',
  ariaHeadingId: 'SampleHeaderId',
});

export const exampleContent = () => {
  return (
    <div>
      <p>
        In user interface design for computer applications, a modal window is a
        graphical control element subordinate to an application's main window.
        It creates a mode that disables the main window but keeps it visible,
        with the modal window as a child window in front of it. Users must
        interact with the modal window before they can return to the parent
        application. This avoids interrupting the workflow on the main window.
        Modal windows are sometimes called heavy windows or modal dialogs
        because they often display a dialog box.
      </p>
      <p>Typically modals can be closed by</p>
      <ol>
        <li>
          Clicking the little close button (usually in the upper right-hand
          corner),
        </li>
        <li>
          Tapping anywhere on the darker overlay area behind the modal, or
        </li>
        <li>Pressing the esc key</li>
      </ol>
      <p>
        User interfaces typically use modal windows to command user awareness
        and to display emergency states, though interaction designers argue they
        are ineffective for that use. Modal windows are prone to mode errors.
      </p>
    </div>
  );
};
